const getEmbedType = (useCaseEmbed) => {
  const { source, url } = useCaseEmbed.attributes

  if (['youtube', 'vimeo', 'tiktok', 'x'].includes(source)) {
    return 'video'
  }

  if (source === 'upload' && url) {
    const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'm4v']
    const fileExtension = url.split('.').pop()?.toLowerCase()

    if (fileExtension && videoExtensions.includes(fileExtension)) {
      return 'video'
    }
  }

  return 'image'
}

const findUseCasesEmbed = (allUseCaseEmbeds, useCaseEmbedsIds) => {
  return normalizeUseCaseEmbeds(
    (allUseCaseEmbeds || [])
      .filter((useCaseEmbed) => useCaseEmbedsIds.includes(useCaseEmbed.id))
  )
}

const normalizePrinterType = (printerType) => {
  if (!printerType) return null

  return {
    id: printerType.id,
    name: printerType.name,
    createdAt: printerType.created_at,
    updatedAt: printerType.updated_at,
    hidden: printerType.hidden,
    manufacturerId: printerType.manufacturer_id,
  }
}

export const normalizeUseCasesResponse = (response) => {
  const allUseCases = response?.data
  const allUseCaseEmbeds = response?.included

  if (!Array.isArray(allUseCases)) return []

  return allUseCases.reduce((prev, current) => {
    prev.push({
      ...current.attributes,
      id: current.id,
      isLoading: false,
      printerType: normalizePrinterType(current.attributes.printerType),
      userAvatar: current.attributes?.avatar?.small_url || current.attributes?.user_avatar?.large_url || '',
      useCaseEmbeds: findUseCasesEmbed(
        allUseCaseEmbeds,
        (current.relationships?.useCaseEmbeds?.data || []).map((useCaseEmbed) => useCaseEmbed.id)
      ),
    })

    return prev
  }, [])
}

export const TECHNOLOGY_OPTIONS = [
  {
    label: 'FDM',
    value: 'fdm',
  },
  {
    label: 'SLA',
    value: 'sla',
  },
  {
    label: 'SLS',
    value: 'sls',
  },
  {
    label: 'PolyJet',
    value: 'poly_jet',
  },
  {
    label: 'Metal 3D Printing',
    value: 'metal_printing',
  },
  {
    label: 'Multi Jet Fusion',
    value: 'metal_jet',
  },
  {
    label: 'Other',
    value: 'other',
  },
]

export const getTechnologyLabel = (value) => {
  const technology = TECHNOLOGY_OPTIONS.find(option => option.value === value)
  return technology ? technology.label : value
}

export const MATERIAL_OPTIONS = [
  {
    label: 'PLA',
    value: 'pla',
  },
  {
    label: 'ABS',
    value: 'abs',
  },
  {
    label: 'PETG',
    value: 'petg',
  },
  {
    label: 'Resin',
    value: 'resin',
  },
  {
    label: 'TPU (Flexible)',
    value: 'tpu',
  },
  {
    label: 'Nylon',
    value: 'nylon',
  },
  {
    label: 'Other',
    value: 'other',
  },
]

export const PRINT_RESULT_OPTIONS = [
  {
    label: 'Printed successfully',
    value: 'success',
  },
  {
    label: 'Minor issues',
    value: 'minor_issues',
  },
  {
    label: 'Print failed',
    value: 'failed',
  },
]

export const PRINT_TIME_OPTIONS = [
  {
    label: 'Under 2 hours',
    value: 'under_2h',
  },
  {
    label: '2–5 hours',
    value: '2_5h',
  },
  {
    label: '5–10 hours',
    value: '5_10h',
  },
  {
    label: 'Over 10 hours',
    value: 'over_10h',
  },
]

export const getMaterialLabel = (value) => {
  const material = MATERIAL_OPTIONS.find(option => option.value === value)
  return material ? material.label : value
}

export const getPrintTimeLabel = (value) => {
  const printTime = PRINT_TIME_OPTIONS.find(option => option.value === value)
  return printTime ? printTime.label : value
}

export const normalizeUseCaseEmbeds = (rawEmbeds) => {
  return (rawEmbeds || [])
    .map((useCaseEmbed) => ({
      ...useCaseEmbed.attributes,
      id: useCaseEmbed.id,
      type: getEmbedType(useCaseEmbed),
    }))
}
